import { WebApiActionGet } from "components/ajax/WebApi";
import rootUrl from "./url";

export enum LicenceType {
    Member,
    Amateur,
    Proffesional,
    Adjudicator,
    Couch,
    Official,
}

export enum LicenceGrade {
    Unspecified = 0,
    III, II, I,
}

export enum Discipline {
    Any,
}

export interface Licence {
    memberId: number;
    type: LicenceType;
    grade: LicenceGrade;
    discipline: Discipline;
}

export interface DisplayLicence {
    type: LicenceType;
    grade: LicenceGrade;
}

export const apiGetLicences = function (memberIdt: number, forDate?: Date): WebApiActionGet<DisplayLicence[]> {
    const forDateParam = forDate ? `${forDate.toISOString()}` : "";
    return new WebApiActionGet<DisplayLicence[]>(rootUrl + `${memberIdt}/licencess?forDate=` + forDateParam);
}

